import clsx from 'clsx';
import {motion} from 'framer-motion';

const SHARED_LIST_CLASSES = clsx(
  'first:mt-0 last:mb-0', //
  'space-y-0.5 leading-paragraph list-outside ml-8',
  'richH7',
);

const lineVars = {
  initial: {
    opacity: 0,
    y: 20,
  },
  animate: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: [0.6, 0.05, 0.01, 0.9],
    },
  },
};

export default function ListBlock(props: any) {
  const {children, type} = props;

  switch (type) {
    case 'bullet':
      return (
        <motion.ul variants={lineVars} className={SHARED_LIST_CLASSES}>
          {children}
        </motion.ul>
      );
    case 'number':
      return (
        <motion.ol variants={lineVars} className={SHARED_LIST_CLASSES}>
          {children}
        </motion.ol>
      );
    default:
      null;
  }
}
